<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import {getNoticeMessage, updateNoticeMessageStatus} from "./api/login";
import store from "./store";
import {getToken} from "./utils/auth";

export default {
    name: 'App',
    data() {
        return {
            heartBeatInterval: null,
            msgIds: [],
        }
    },
    created() {
        setTimeout(res => {
            let token = store.getters.token;
            if (token) {
                token = getToken()
            }
            if (token !== undefined && token !== null) {
                this.initWebSocket();
                this.initNoticeMessage();
            }
        }, 2000)
    },
    mounted() {
        this.$bus.$on("initWebSocket", (data) => {
            this.initWebSocket();
        });
        this.$bus.$on("initNoticeMessage", (data) => {
            this.initNoticeMessage();
        })
    },
    methods: {
        initNoticeMessage() {
            this.msgIds = [];
            // this.$notify.closeAll();
            getNoticeMessage().then(res => {
                let list = res.data;
                for (let i = 0; i < list.length; i++) {
                    let item = list[i];
                    if (item.chatType === 2 && item.readStatus === 0) {
                        let content = item.content;
                        let title = item.title;
                        setTimeout(res => {
                            let index = this.msgIds.indexOf(item.id);
                            if (index === -1) {
                                this.msgIds.push(item.id)
                                this.$notify.info({
                                    title: title,
                                    message: content,
                                    duration: 0,
                                    offset: 100,
                                    onClose: () => {
                                        this.updateNoticeMessageStatus(item.id);
                                    }
                                });
                            }
                        }, 500)
                    }
                }
            })

        },
        updateNoticeMessageStatus(id) {
            updateNoticeMessageStatus(id).then(res => {

            });
        },
        initWebSocket() {
            let token = store.getters.token;
            if (token) {
                token = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
            }
            if (token === undefined || token === null) {
                token = "";
            }
            if (this.$socket !== undefined && this.$socket !== null) {
                this.$socket.close();
            }
            let platform = "admin";
            const wsUrl = process.env.BASE_WS + '?platform=' + platform + '&token=' + token;//ws 地址
            this.$socket = new WebSocket(wsUrl);
            this.$socket.onopen = this.wsOnOpen;//连接成功方法
            this.$socket.onerror = this.wsOnError;//报错方法
            this.$socket.onmessage = this.wsOnMessage;// 接收端返回或推送信息的方法
            this.$socket.onclose = this.wsOnClose;//关闭
        },
        // 链接ws服务器，e.target.readyState = 0/1/2/3   0 CONNECTING ,1 OPEN, 2 CLOSING, 3 CLOSED
        wsOnOpen(e) {
            console.log('WebSocket连接成功', e);
            this.heartBeat(5000);
        },
        wsOnClose(e) {
            //先将心跳与重连的定时器清除
            clearInterval(this.heartBeatInterval)
            if (this.$socket !== null && this.$socket !== undefined) {
                this.$socket.reconnectionAttempts = 20;
            }
            console.log('WebSocket连接关闭', e);
        },
        wsOnError(err) {
            console.log('WebSocket错误', err);
        },
        // 接收端发送过来的信息，整个项目接收信息的唯一入口
        wsOnMessage(e) {
            // console.log(e)
            let data = e.data;
            if (data !== undefined && data !== null) {
                let res = JSON.parse(e.data);
                if (res.chatType === 2) {
                    let content = res.content;
                    let title = res.title;
                    let id = res.extras.messageId;
                    setTimeout(res => {
                        let index = this.msgIds.indexOf(id);
                        if (index === -1) {
                            this.msgIds.push(id)
                            this.$notify.info({
                                title: title,
                                message: content,
                                duration: 0,
                                offset: 100,
                                onClose: () => {
                                    this.updateNoticeMessageStatus(id);
                                }
                            });
                        }
                    }, 500);
                } else if (res.command === 24) {
                    this.$bus.$emit("wsOnMessage", res.data);
                }
            }
        },
        heartBeat(ms) {
            if (this.$socket === null || this.$socket === undefined) {
                return;
            }
            this.heartBeatInterval = setInterval(() => {
                let data = {"cmd": 13, "hbbyte": -128};
                this.$socket.send(JSON.stringify(data))
            }, ms)
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue